import { IImportationXLSXData } from "api/interfaces/IImportationXLSXData";
import { onSnapshot, Unsubscribe } from "firebase/firestore";
import ContractImportException from "../exceptions/ContractImportException";
import { callFunction, getDocumentRef } from "./FirebaseRepository";

class ContractImportRepository {
  private pathXLSX = "importXLSX";

  scheduleContractImport(
    convert: { destination: string; id: string; fields: {}[] },
    fileName: string
  ): Promise<any> {
    const data = {
      convert: JSON.stringify(convert),
      filename: fileName,
    };

    return callFunction("importXLSX-import/create", data).then(
      (response: any) => response.data
    );
  }

  subscribeImportSnapshot(
    uid: string,
    onChange: (data: IImportationXLSXData) => void
  ): Unsubscribe {
    const doc = getDocumentRef(this.pathXLSX, uid);

    return onSnapshot(
      doc,
      async (snapshot) => {
        const data = snapshot.data();
        if (data) {
          const { id, status, message, progress, progressDetail, start } = data;
          const error =
            status === "error" ? new ContractImportException(message) : null;

          onChange({
            id,
            status,
            message,
            progress,
            progressDetail,
            error,
            start: start.toDate(),
          });
        }
      },
      (error) => console.error("ImportSnapshot", error)
    );
  }
}

export default ContractImportRepository;
